export const countClick = {
  data() {
    return {
      flag: 1
    }
  },
  methods: {
    clickEvent(item) {
      console.log("click事件");
    },

  }
}



// WEBPACK FOOTER //
// ./src/common/mixin.js